const MAGIC_LINK_ACCOUNT_SESSION_KEY = 'od_magic_link_account_reauth';

export function markMagicLinkAccountSession(): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(MAGIC_LINK_ACCOUNT_SESSION_KEY, '1');
}

export function isMagicLinkAccountSession(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return sessionStorage.getItem(MAGIC_LINK_ACCOUNT_SESSION_KEY) === '1';
}

export function clearMagicLinkAccountSession(): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.removeItem(MAGIC_LINK_ACCOUNT_SESSION_KEY);
}
